import { render, staticRenderFns } from "./BuyerCheckbox.vue?vue&type=template&id=75bc28a1&lang=pug&"
import script from "./BuyerCheckbox.vue?vue&type=script&lang=js&"
export * from "./BuyerCheckbox.vue?vue&type=script&lang=js&"
import style0 from "./BuyerCheckbox.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('75bc28a1')) {
      api.createRecord('75bc28a1', component.options)
    } else {
      api.reload('75bc28a1', component.options)
    }
    module.hot.accept("./BuyerCheckbox.vue?vue&type=template&id=75bc28a1&lang=pug&", function () {
      api.rerender('75bc28a1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "node_modules/sales-flow-ui/components/BuyerCheckbox.vue"
export default component.exports